import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import { ProofSection } from '../components/ProofSection';
import { Navigation } from '../components/Navigation';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const schedule = [{
  time: '4:30pm-5:10pm',
  monday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  tuesday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  wednesday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: 'Hyper',
    subtext: '',
    color: 'bg-cyan-400'
  },
  saturday: {
    class: 'Appointment &',
    subtext: 'Private Lesson',
    color: 'bg-gray-100'
  }
}, {
  time: '5:10pm-5:50pm',
  monday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  tuesday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  wednesday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: 'Beginner',
    subtext: 'Sparring',
    color: 'bg-blue-400'
  },
  saturday: {
    class: 'Appointments &',
    subtext: 'Private Lesson',
    color: 'bg-gray-100'
  }
}, {
  time: '5:50pm-6:30pm',
  monday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-red-500 text-white'
  },
  tuesday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  wednesday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-red-500 text-white'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Family)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-blue-600 text-white'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-gray-100'
  }
}, {
  time: '5:50pm-6:30pm',
  monday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  tuesday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  wednesday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  thursday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  friday: {
    class: 'Team',
    subtext: '1&2',
    color: 'bg-gray-400'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-gray-100'
  }
}, {
  time: '6:30pm-7:20pm',
  monday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  tuesday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  wednesday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  thursday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-orange-400'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-gray-100'
  }
}, {
  time: '7:20pm-9:00pm',
  monday: {
    class: '',
    subtext: '',
    color: 'bg-green-300'
  },
  tuesday: {
    class: '',
    subtext: '',
    color: 'bg-green-300'
  },
  wednesday: {
    class: '',
    subtext: '',
    color: 'bg-green-300'
  },
  thursday: {
    class: '',
    subtext: '',
    color: 'bg-green-300'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-orange-400'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-gray-100'
  }
}];
const legend = [{
  label: 'Beg - White - H.Green',
  color: 'bg-yellow-300'
}, {
  label: 'Intermediate - Blue - Red',
  color: 'bg-blue-400'
}, {
  label: 'BB Prep - Bo Dan/Black Belts',
  color: 'bg-red-500 text-white'
}, {
  label: 'Adults - All Belt Levels',
  color: 'bg-gray-400'
}, {
  label: 'Hyper',
  color: 'bg-cyan-400'
}, {
  label: 'Team (Level 1,2, and 3)',
  color: 'bg-gray-300'
}, {
  label: 'Juice Compound',
  color: 'bg-orange-400'
}, {
  label: 'Youth Cadet (12 and Under)',
  color: 'bg-green-300'
}];
export function SchedulePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-456">
      <Navigation data-id="element-457" />

      {/* Hero Section */}
      <section className="pt-16 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-458">
        <div className="max-w-6xl mx-auto text-center" data-id="element-459">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-460">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-461">
              <Calendar className="w-8 h-8 text-[#1e3a8a]" data-id="element-462" />
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-[#1e3a8a]" data-id="element-463">
                Class Schedule
              </h1>
            </div>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-464">
              Find the perfect class time for your family. All classes are
              designed to build confidence, discipline, and skill.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Schedule Table */}
      <section className="py-16 px-4" data-id="element-465">
        <div className="max-w-6xl mx-auto" data-id="element-466">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-467">
            {/* Desktop Table */}
            <div className="hidden lg:block overflow-x-auto" data-id="element-468">
              <table className="w-full border-collapse shadow-lg rounded-xl overflow-hidden" data-id="element-469">
                <thead data-id="element-470">
                  <tr className="bg-[#1e3a8a] text-white" data-id="element-471">
                    <th className="p-4 text-left font-bold border border-blue-900" data-id="element-472">
                      <Clock className="w-5 h-5 inline mr-2" data-id="element-473" />
                      Time
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-474">
                      Monday (A)
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-475">
                      Tuesday (A)
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-476">
                      Wednesday (B)
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-477">
                      Thursday (B)
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-478">
                      Friday (Specialty)
                    </th>
                    <th className="p-4 text-center font-bold border border-blue-900" data-id="element-479">
                      Saturday
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-480">
                  {schedule.map((row, idx) => <tr key={idx} data-id="element-481">
                      <td className="p-4 font-semibold text-gray-700 border border-gray-200 bg-gray-50" data-id="element-482">
                        {row.time}
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.monday.color}`} data-id="element-483">
                        <div className="font-semibold" data-id="element-484">{row.monday.class}</div>
                        <div className="text-sm" data-id="element-485">{row.monday.subtext}</div>
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.tuesday.color}`} data-id="element-486">
                        <div className="font-semibold" data-id="element-487">{row.tuesday.class}</div>
                        <div className="text-sm" data-id="element-488">{row.tuesday.subtext}</div>
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.wednesday.color}`} data-id="element-489">
                        <div className="font-semibold" data-id="element-490">
                          {row.wednesday.class}
                        </div>
                        <div className="text-sm" data-id="element-491">{row.wednesday.subtext}</div>
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.thursday.color}`} data-id="element-492">
                        <div className="font-semibold" data-id="element-493">
                          {row.thursday.class}
                        </div>
                        <div className="text-sm" data-id="element-494">{row.thursday.subtext}</div>
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.friday.color}`} data-id="element-495">
                        <div className="font-semibold" data-id="element-496">{row.friday.class}</div>
                        <div className="text-sm" data-id="element-497">{row.friday.subtext}</div>
                      </td>
                      <td className={`p-4 text-center border border-gray-200 ${row.saturday.color}`} data-id="element-498">
                        <div className="font-semibold" data-id="element-499">
                          {row.saturday.class}
                        </div>
                        <div className="text-sm" data-id="element-500">{row.saturday.subtext}</div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            {/* Mobile Schedule */}
            <div className="lg:hidden space-y-6" data-id="element-501">
              {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, dayIdx) => <div key={day} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-502">
                  <div className="bg-[#1e3a8a] text-white p-4 font-bold text-lg" data-id="element-503">
                    {day}
                  </div>
                  <div className="divide-y divide-gray-200" data-id="element-504">
                    {schedule.map((row, idx) => {
                  const dayKey = day.toLowerCase() as keyof typeof row;
                  const cell = row[dayKey] as {
                    class: string;
                    subtext: string;
                    color: string;
                  };
                  if (!cell || !cell.class) return null;
                  return <div key={idx} className={`p-4 ${cell.color}`} data-id="element-505">
                          <div className="flex justify-between items-start" data-id="element-506">
                            <div data-id="element-507">
                              <div className="font-semibold" data-id="element-508">{cell.class}</div>
                              <div className="text-sm" data-id="element-509">{cell.subtext}</div>
                            </div>
                            <div className="text-sm font-medium text-gray-600" data-id="element-510">
                              {row.time}
                            </div>
                          </div>
                        </div>;
                })}
                  </div>
                </div>)}
            </div>

            {/* Legend */}
            <div className="mt-12 bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-511">
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-4" data-id="element-512">
                Class Legend
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-513">
                {legend.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-514">
                    <div className={`w-6 h-6 rounded ${item.color} border border-gray-300`} data-id="element-515"></div>
                    <span className="text-sm font-medium text-gray-700" data-id="element-516">
                      {item.label}
                    </span>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-517">
        <div className="max-w-4xl mx-auto text-center" data-id="element-518">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-519">
            <h2 className="text-3xl sm:text-4xl font-black text-[#1e3a8a] mb-6" data-id="element-520">
              Ready to Get Started?
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-521">
              Try any class for 2 weeks and experience the NWBBA difference. No
              long-term commitment required.
            </p>
            <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors" data-id="element-522">
              Start Your $29 Trial
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Proof Section */}
      <ProofSection testimonialIndex={3} data-id="element-523" />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-524">
        <div className="max-w-4xl mx-auto" data-id="element-525">
          <div className="font-black text-xl text-white mb-4 tracking-tighter" data-id="element-526">
            NWBBA
          </div>
          <p className="mb-6" data-id="element-527">Northwest Black Belt Academy</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8" data-id="element-528">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-529">
              Home
            </Link>
            <Link to="/about" className="hover:text-white transition-colors" data-id="element-530">
              About
            </Link>
            <Link to="/classes" className="hover:text-white transition-colors" data-id="element-531">
              Classes
            </Link>
            <Link to="/schedule" className="text-white font-bold" data-id="element-532">
              Schedule
            </Link>
            <Link to="/resources" className="hover:text-white transition-colors" data-id="element-533">
              Resources
            </Link>
            <Link to="/blog" className="hover:text-white transition-colors" data-id="element-534">
              Blog
            </Link>
            <Link to="/proof" className="hover:text-white transition-colors" data-id="element-535">
              Proof
            </Link>
            <a href="#" className="hover:text-white transition-colors" data-id="element-536">
              Contact
            </a>
          </div>
          <p data-id="element-537">
            &copy; {new Date().getFullYear()} Northwest Black Belt Academy. All
            rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}